<template>
  <div class="transactions">
    <a :href="$link" class="back-home">Tilbage</a>
    <div class="main-title">
      <h2 v-if="title">{{ title }}</h2>
      <span v-if="showAllLink"><a :href="'#/transactions'">Se alle</a></span>
    </div>
    <template v-if="transactions.total > 0">
      <div class="table-container">
        <table>
          <thead>
            <tr>
              <th scope="col">Partner</th>
              <th class="type" scope="col">Type</th>
              <th scope="col">Beløb</th>
              <th scope="col">Optjent/Brugt</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="transaction in TransactionsPagination">
              <tr v-for="items in transaction" v-bind:class="{unsettled: items.data.state.settled == false && items.type == 'purchase', settled: items.data.state.settled == true}">
                <td class="partner-date">
                  <span v-if="items.type == 'withdrawal'" class="partner">
                    Udbetaling
                    <span
                      v-tooltip="{
                        content: 'Vi sætter cashback til udbetaling en gang ugentligt om fredagen.\n Derefter kan du forvente at have beløbet på din bankkonto inden for 1-2 bankdage.\n Hvis du har anmodet om udbetaling senest torsdag aften, sætter vi din cashback til udbetaling fredag i samme uge.',
                        placement: 'top-center',
                        classes: ['transaction-tooltip'],
                      }"
                      class="des-tooltip"
                    >
                    </span>
                  </span>
                  <span v-else-if="items.data.state.authorised && !items.data.state.settled && !items.data.state.cancelled && !items.data.state.declined" class="partner">
                    <expandable-text-line :use-click="true" class="expand_text" :duration="0">
                      {{ items.name }}
                    </expandable-text-line>
                    <span
                      v-tooltip="{
                        content: `Afventende optjening betyder, at din cashback er registreret, men endnu ikke tilgængelige. Cashback'en skifter status til bekræftet, når vi har modtaget betalingen fra partneren. Læs mere i vores FAQ.`,
                        placement: 'top-center',
                        classes: ['transaction-tooltip'],
                      }"
                      class="des-tooltip"
                    >
                    </span>
                  </span>
                  <span v-else-if="!items.data.state.authorised && !items.data.state.cancelled && !items.data.state.declined && !items.data.state.settled && !items.data.state.withdrawn && items.type === 'purchase'" class="partner">
                    <expandable-text-line :use-click="true" class="expand_text" :duration="0">
                      {{ items.name }}
                    </expandable-text-line>
                    <span
                      v-tooltip="{
                        content: 'Reserveret optjening betyder, vi har registeret dit køb, men at pengene ikke er trukket i din bank endnu. Når pengene er trukket, vil både købsbeløb og cashback fremgå. Læs mere i vores FAQ.',
                        placement: 'top-center',
                        classes: ['transaction-tooltip'],
                      }"
                      class="des-tooltip"
                    >
                    </span>
                  </span>
                  <span v-else-if="items.type == 'refund'" class="partner" v-html="items.name.substring(0, items.name.indexOf('(ID'))"></span>
                  <span v-else class="partner">
                    <expandable-text-line :use-click="true" class="expand_text" :duration="0">
                      {{ items.name | sanitizeTitle }}
                    </expandable-text-line></span
                  >
                  <span class="date">{{ items.timestamp | formatDate }}</span>
                </td>
                <td class="type">{{ items.type | translateType }}</td>
                <td v-if="!items.data.state.authorised && !items.data.state.cancelled && !items.data.state.declined && !items.data.state.settled && !items.data.state.withdrawn && items.type === 'purchase'"><span class="status reserved">Reserveret</span></td>
                <td v-else-if="items.type != 'transfer'">{{ items.amount | localizeCurrency }}</td>
                <td v-else>-</td>
                <td :class="{negative: items.reward_amount < 0, positive: items.reward_amount >= 0}">
                  <template v-if="items.data.state.settled === true">
                    {{ formatAmount(items.reward_amount) }}
                    <span class="status">Bekræftet</span>
                  </template>
                  <template v-else-if="items.data.state.authorised && !items.data.state.settled && !items.data.state.cancelled && !items.data.state.declined">
                    {{ formatAmount(items.reward_amount) }}
                    <span class="status">Afventende</span>
                  </template>
                  <template v-else-if="items.data.state.cancelled || items.data.state.declined">
                    {{ formatAmount(items.reward_amount) }}
                    <span class="status">Annulleret</span>
                  </template>
                  <template v-else-if="!items.data.state.authorised && !items.data.state.cancelled && !items.data.state.declined && !items.data.state.settled && !items.data.state.withdrawn && items.type === 'purchase'">
                    <span class="status reserved">Reserveret</span>
                  </template>
                  <template v-else-if="items.type === 'refund' || items.type === 'debit'">
                    <span class="status">Refunderet</span>
                  </template>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>
    <template v-else>
      <p class="no-content">Du har endnu ingen transaktioner</p>
    </template>
    <div class="btn-box show-more-btn" v-if="offset < transactions.total">
      <button v-on:click="getTransactions" @click="loading = true">Se flere</button>
      <span v-show="loading == true" class="loading"></span>
    </div>
  </div>
</template>
<style>
.transaction-tooltip {
  max-width: 435px;
}
</style>

<script>
import ExpandableTextLine from 'vue-expandable-text-line'

export default {
  name: 'Transactions',

  components: {
    ExpandableTextLine,
  },

  props: {
    title: {
      type: String,
      default: 'Kontobevægelser',
    },
    limit: {
      type: [String, Number],
      default: 10,
    },
    showAllLink: Boolean,
  },

  data() {
    return {
      transactions: {
        total: 0,
        items: [],
      },
      offset: 0,
      TransactionsPagination: [],
      loading: false,
    }
  },

  mounted() {
    this.getTransactions()
  },

  methods: {
    getTransactions() {
      this.$cashback.transactions(this.limit, this.offset).then((data) => {
        this.transactions = data
        this.TransactionsPagination.push(this.transactions.items)
        this.offset += parseInt(this.limit)
        this.loading = false
        this.$emit('loaded')
      })
    },
  },

  filters: {
    sanitizeTitle(title) {
      return title.replace('Transfer in: ', '').replace('Transfer out: ', '')
    },

    translateType(type) {
      let translatedType = ''

      switch (type) {
        case 'withdrawal':
          translatedType = 'Udbetalt'
          break
        case 'purchase':
          translatedType = 'Køb'
          break
        case 'bonus':
          translatedType = 'Bonus'
          break
        case 'refund':
          translatedType = 'Refundering'
          break
        case 'partial_refund':
          translatedType = 'Delvis refundering'
          break
        case 'transfer':
          translatedType = 'Overførsel'
          break

        default:
          translatedType = type
          break
      }

      return translatedType
    },
  },
}
</script>
